// import { useEffect, useState } from "react";
// import TabNavigator from "../components/TabNavigatorComponent";
// import JozunaSkillUp from "../components/JozunaSkillUpVedioPage";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../styles/JozunaSkillUpPageStyle.css";
// import { useAlert } from "../../../../components/AlertContextComponent";
// import { useApi } from "../../../../service/ApiContext";
// import Logger from "../../../../utils/Logger";
// import {
//   Recommendation,
//   videoLandingPageResponse,
// } from "../data/response/VideoLandingPageResponse";
// import "../../vedio-recommendation/styles/TabNavigatorStyle.css";
// import AssessmentNotFound from "../../../../assets/images/recommandation/assessmentNotFound.png";
// import { videolandingPageRequest } from "../data/request/VideoLandingPageRequest";
// import VideoLandingPageClient from "../data/api/VideoLandingPageClient";
// import Loader, { LocalStorage } from "../../../../utils/Utils";
// import { recommendationIndustryViewInstance_Store } from "./../../recommendation_industry_view/data/instance_store/Recommendation_IndustryView_Instance";
// import { recommendationJozunaViewInstance_Store } from "../../recommendationJozunaView/data/instance_store/Recommendation_JozunaView_Instance";
// import NoRecommendationImage from "../../../../assets/images/norecommendation_screen.svg";
// import NoProgramHubImage from "../../../../assets/images/noProgramHubImg.png";

// import { Box, Button, MenuItem, Popover } from "@mui/material";
// import DropDown from "../../../../assets/images/recommandation/dropdown.svg";
// import NeedHelp from "../../assets/images/NeedHelp.svg";
// import RightModal from "../../needHelp/pages/NeedHelpPage";
// import { useDispatch, useSelector } from "react-redux";
// import { RootState } from "../../../../store/store";
// import { setJozunaSelectedProgram } from "../data/redux/JozunaDropdown";
// import { logActionEvent } from "../../../../analytics/analytics_utils";
// import analytics_strings from "../../../../analytics/analytics_strings";

// type VideoLandingPageProps = {
//   activeTb: number; // Adjust the type as needed
// };
// const VideoLandingPage: React.FC<VideoLandingPageProps> = ({ activeTb }) => {
//   // State to track active tab
//   const navigate = useNavigate();
//   const { showAlert } = useAlert();
//   const location = useLocation();
//   const active = location.state?.active;
//   const [activeTab, setActiveTab] = useState(activeTb);
//   const api = useApi();
//   const handleTabChange = (index: number) => {
//     setActiveTab(index);
//   };
//   const [isModalOpen, setModalOpen] = useState(false); // State to control modal visibility
//   const [industry, setIndustryData] = useState<Recommendation[] | null>(null);
//   const [cardData, setCardData] = useState<Recommendation[] | null>(null);
//   const [jozunaRecommendation, setJozunaRecommendation] = useState<string>("");
//   const [jozunaDuration, setJozunaDuration] = useState(0);
//   const [industryDuration, setIndustryDuration] = useState(0);
//   const [assessmentFound, setAssessmentFound] = useState(false);
//   //Loading to fix Flickering Issue
//   const [loading, setLoading] = useState(false);
//   const [Apptoken, setAppToken] = useState<string | null>(null);
//   // const [fromFlutter, setFromFlutter] = useState(false);

//   const dispatch = useDispatch();
//   const selectedProgram = useSelector(
//     (state: RootState) => state.JozunaDropdown.JozunaSelectedProgram
//   );

//   const useQuery = () => {
//     return new URLSearchParams(useLocation().search);
//   };

//   // Retrieve saved selection from localStorage on page load
//   useEffect(() => {
//     const savedOption =
//       activeTab === 0
//         ? JSON.parse(
//             LocalStorage.getLocalData("selectedOptionJozuna") || "null"
//           )
//         : JSON.parse(LocalStorage.getLocalData("selectedOption") || "null");

//     if (savedOption) {
//       if (activeTab === 0) {
//         setSelectedOptionJozuna(savedOption);
//       } else {
//         setSelectedOption(savedOption);
//       }
//       getCourseDetail(activeTab, savedOption.id); // Load the corresponding course
//     } else {
//       // getProgram(); // Load default program data
//     }
//   }, [activeTab]);

//   const query = useQuery();
//   useEffect(() => {
//     const tokenFromURL = query.get("token");
//     const regionFromURL = query.get("region");
//     // Handling token
//     if (tokenFromURL) {
//       Logger.info("Token successfully retrieved from URL:", tokenFromURL);
//       LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
//       LocalStorage.setLocalData("fromFlutter", "true");
//     } else {
//       Logger.info("No token found in URL. Using appToken:");
//       const storedToken = LocalStorage.getLocalData("access_token");
//       Logger.info(
//         "No token found in URL. Using appToken**************:",
//         storedToken
//       );

//       if (storedToken) {
//         setAppToken(storedToken); // Use the token from local storage if not found in URL
//         LocalStorage.setLocalData("access_token", storedToken);
//       }
//     }

//     // Handling region
//     if (regionFromURL) {
//       Logger.info("Region successfully retrieved from URL:", regionFromURL);
//       LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
//       LocalStorage.setLocalData("fromFlutter", "true");
//     } else {
//       Logger.info("No region found in URL.");
//     }
//     // Check if data for the current tab has already been loaded
//     if (
//       (activeTab === 0 && jozunaRecommendation !== "jozuna") ||
//       (activeTab === 1 && !industry)
//     ) {
//       getProgram();
//     }
//     return () => {
//       recommendationIndustryViewInstance_Store.clearState(); //Clean Up Recommendation Industry View SelectedItem
//       recommendationJozunaViewInstance_Store.clearState(); //Clean Up Recommendation Jozuna View SelectedItem
//     };
//   }, [activeTab, jozunaRecommendation, industry]);
//   const getCourseDetail = async (tab: number, id: string) => {
//     Loader.showLoading("Loading...");
//     setLoading(true);
//     const param: videolandingPageRequest = {
//       recommendation_type: tab == 0 ? "Jozuna" : "Industry",
//       program_id: id,
//     };
//     Logger.info("param", param);
//     Logger.info("Selected options", selectedOption?.title);

//     api.setAuthToken(LocalStorage.getLocalData("access_token"));

//     try {
//       // showAlert({
//       //   show: true,
//       //   title: "Session Expired",
//       //   message: "Session timed out. Please login again",
//       //   button1Text: "OK",
//       //   alertType: "success",
//       //   onlyNeedOneButton: true,
//       //   btn1onPressed: () => {
//       //     LocalStorage.deleteAllLocalData();
//       //     // Use history.replaceState to avoid adding a new history entry
//       //     // window.history.replaceState({}, "", "/");
//       //     // window.location.reload(); // Optional: Reload to reflect changes
//       //     const envUrl =
//       //       process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
//       //     window.parent.postMessage("logout", "*");
//       //     // if (window.top) {
//       //     //   Logger.error("window top link");
//       //     //   window.top.location.reload();

//       //     //   window.top.location.href =
//       //     //     process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
//       //     // } else {
//       //     //   // Fallback in case window.top is null
//       //     //   Logger.error(
//       //     //     "Unable to access window.top. Redirecting within iframe."
//       //     //   );
//       //     //   window.location.href =
//       //     //     process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
//       //     // }
//       //   },
//       // });
//       const response = await api.get<videoLandingPageResponse>(
//         VideoLandingPageClient.landingPageURL,
//         param
//       );
//       Logger.info("response", response.data);
//       if (response.data.error != null) {
//         showAlert({
//           show: true,
//           title: "Error",
//           message: response.data.error,
//           button1Text: "Cancel",
//           alertType: "error",
//           onlyNeedOneButton: true,
//           btn1onPressed: () => {
//             ("");
//           },
//         });
//       } else if (
//         response.data.recommendation.length === 0 &&
//         response.data.error == null
//       ) {
//         setAssessmentFound(true);
//       } else {
//         setAssessmentFound(false);
//       }
//       const courseData = response.data.recommendation || [];
//       const type = response.data.recommendation_type.toLowerCase();
//       const sortedCourseData = courseData.sort(
//         (a, b) => a.seq_number - b.seq_number
//       );
//       // Sort the courseData immediately before setting it to state
//       if (type === "industry") {
//         setIndustryData(sortedCourseData);
//         setIndustryDuration(response.data.total_duration);
//       } else if (type === "jozuna") {
//         setJozunaDuration(response.data.total_duration);
//         setCardData(sortedCourseData);
//         setJozunaRecommendation("jozuna");
//       }
//     } catch (error) {
//       Logger.info("error response", error);
//       if (activeTab == 1) {
//         setIndustryData([]);
//         setIndustryDuration(0);
//       } else {
//         setJozunaDuration(0);
//         setCardData([]);
//       }
//     } finally {
//       Loader.dismissLoading();
//       setLoading(false);
//     }
//   };

//   const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
//   const [programOptions, setProgramOptions] = useState<
//     { id: string; title: string; description: string }[]
//   >([]);
//   const [selectedOption, setSelectedOption] = useState<{
//     id: string;
//     title: string;
//     description: string;
//   } | null>(null);
//   const [programOptionsJozuna, setProgramOptionsJozuna] = useState<
//     { id: string; title: string; description: string }[]
//   >([]);
//   const [selectedOptionJozuna, setSelectedOptionJozuna] = useState<{
//     id: string;
//     title: string;
//     description: string;
//   } | null>(null);
//   const [selectedId, setSelectedId] = useState("");
//   const [selectedDesc, setSelectedDesc] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   // Select the data from the Redux store
//   const userData = useSelector((state: RootState) => state.profile.profileKeys);
//   const handleClickDrop = (event: React.MouseEvent<HTMLDivElement>) => {
//     setAnchorEl2(event.currentTarget);
//   };

//   const handleClose2 = () => {
//     setAnchorEl2(null);
//   };

//   const handleOptionChange = (
//     option: {
//       id: string;
//       title: string;
//       description: string;
//     },
//     tab: number
//   ) => {
//     if (tab === 0) {
//       setSelectedOptionJozuna(option);
//       dispatch(setJozunaSelectedProgram(option));
//     }
//     if (tab === 1) {
//       setSelectedOption(option);
//       // dispatch(setSelectedOptions(option)); // Redux action for other tabs
//       dispatch(setJozunaSelectedProgram(option));
//     }
//     setSelectedId(option.id);
//     getCourseDetail(activeTab, option.id);
//     setSelectedDesc(option.description);
//     setAnchorEl2(null);
//     Logger.info("selected option", selectedOption);
//     Logger.info("selected Idd", selectedId);
//     dispatch(setJozunaSelectedProgram(option)); // Save the selected program to Redux
//     setIsOpen(false);
//   };

//   // const handleOptionChange = (
//   //   option: {
//   //     id: string;
//   //     title: string;
//   //     description: string;
//   //   },
//   //   tab: number
//   // ) => {
//   //   if (tab == 0) {
//   //     setSelectedOptionJozuna(option);
//   //   }
//   //   if (tab == 1) {
//   //     setSelectedOption(option);
//   //   }
//   //   setSelectedId(option.id);
//   //   getCourseDetail(activeTab, option.id);
//   //   setSelectedDesc(option.description);
//   //   setAnchorEl2(null);
//   //   Logger.info("selected option", selectedOption);
//   //   Logger.info("selected Idd", selectedId);
//   //   setIsOpen(false);
//   // };

//   const getProgram = async () => {
//     Loader.showLoading("Loading...");
//     setLoading(true);

//     api.setAuthToken(LocalStorage.getLocalData("access_token"));
//     const param = {
//       program_category: activeTab === 0 ? "Jozuna" : "Industry",
//     };

//     try {
//       const response = await api.get<any>("/list_program", param);

//       // Dispatch programs to Redux store
//       Logger.info("response for details", response.data);

//       // Map program data to options
//       const options = response.data.programs.map((program: any) => ({
//         id: program.program_id,
//         title: program.program_title,
//         description: program.program_description,
//       }));

//       // Set options based on activeTab
//       if (activeTab === 0) {
//         setProgramOptionsJozuna(options);
//       } else {
//         setProgramOptions(options);
//       }

//       // Find the active program
//       const activeProgram =
//         response.data.programs.find(
//           (program: any) => program.status === "Active"
//         ) || response.data.programs[0];

//       if (activeProgram) {
//         const selectedOption = {
//           id: selectedProgram?.id,
//           title: selectedProgram?.description,
//           description: selectedProgram?.title,
//         };

//         const id = selectedProgram?.id;
//         const desc = selectedProgram?.description;
//         setSelectedDesc(desc);

//         Logger.info("idd", id);

//         // Set selected option based on activeTab
//         if (activeTab === 0) {
//           setSelectedOptionJozuna(selectedOption);
//         } else {
//           setSelectedOption(selectedOption);
//           setSelectedId(id);
//         }

//         Logger.info("Selected Options:", selectedOption);
//         Logger.info("Selected Options id:", selectedId);

//         Logger.info("Selected Jozuna Options:", selectedOptionJozuna);

//         // if (!selectedProgram) {
//         //   dispatch(setJozunaSelectedProgram(selectedOption));
//         // }

//         // // Call getEvents only after setting selectedOption
//         // getCourseDetail(activeTab, id);

//         if (!selectedProgram) {
//           const firstOption = options[0]; // Select the first program by default
//           setSelectedDesc(firstOption.description);
//           if (activeTab === 0) {
//             setSelectedOptionJozuna(firstOption);
//           } else {
//             setSelectedOption(firstOption);
//           }
//           dispatch(setJozunaSelectedProgram(firstOption)); // Dispatch to Redux
//           getCourseDetail(activeTab, firstOption.id); // Load the corresponding course
//         } else {
//           getCourseDetail(activeTab, id);
//         }
//       }
//     } catch (error) {
//       Logger.info("error response", error);
//       // Display an error alert or message if needed
//     } finally {
//       Loader.dismissLoading();
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return <div className="landing-page"></div>;
//   }

//   // Function to toggle modal open/close
//   const toggleModal = () => {
//     setModalOpen(!isModalOpen);
//     if (!isModalOpen) {
//       logActionEvent(
//         analytics_strings.analytics_events.reccomendation_needHelp,
//         {
//           candidate_id: userData.candidate_id,
//         }
//       );
//     }
//   };
//   if (programOptionsJozuna.length === 0) {
//     return (
//       <div
//         className="noprogram-landing-page"
//         style={{
//           height:
//             LocalStorage.getLocalData("fromFlutter") !== "true"
//               ? "90vh"
//               : "100vh",
//         }}
//       >
//         <div className="reco-assessment-not-found-container">
//           <img
//             src={NoProgramHubImage}
//             alt="assessment not found"
//             className="noprogram-assessment-not-image"
//           />
//           <div className="assessment-not-image-text">
//             No course has been assigned to this program
//           </div>
//         </div>
//       </div>
//     );
//   }
//   return (
//     <div
//       className="landing-page"
//       style={{
//         height:
//           LocalStorage.getLocalData("fromFlutter") !== "true"
//             ? "90vh"
//             : "100vh",
//       }}
//     >
//       {/* <div className="tab-navigator">
//         <TabNavigator activeTab={activeTab} onTabChange={handleTabChange} />
//       </div> */}
//       <div className="program-dropdown-tab">
//         <div className="program-dropdown">
//           <div className="program-dropdown-text">Programs :</div>
//           <div className="dropdown">
//             <div className="dropdown-select" onClick={handleClickDrop}>
//               {activeTab === 0
//                 ? selectedProgram
//                   ? selectedProgram.title
//                   : "Select an Option"
//                 : selectedOption
//                 ? selectedOption?.title
//                 : "Select an Option"}
//               <img
//                 src={DropDown}
//                 alt="Checkbox Icon"
//                 style={{ width: "12px", height: "15px", marginLeft: "auto" }}
//               />
//             </div>
//             <Popover
//               open={Boolean(anchorEl2)}
//               anchorEl={anchorEl2}
//               onClose={handleClose2}
//               anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//               transformOrigin={{ vertical: "top", horizontal: "left" }}
//               PaperProps={{
//                 style: {
//                   width: "300px",
//                   marginTop: "5px",
//                   borderRadius: "10px",
//                   backgroundColor: "#ffffff",
//                   boxShadow: "#00000040",
//                   padding: "8px 8px",
//                 },
//               }}
//             >
//               <Box sx={{ padding: "0px" }}>
//                 {activeTab === 0 ? (
//                   programOptionsJozuna.length > 0 ? (
//                     programOptionsJozuna.map((option) => (
//                       <MenuItem
//                         key={option.id}
//                         onClick={() => {
//                           handleOptionChange(option, activeTab); // Update local state or perform actions
//                           dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
//                         }}
//                         style={{
//                           fontFamily: "Mazzard",
//                           color: "#242730",
//                           fontSize: "16px",
//                           fontWeight: "500",
//                         }}
//                       >
//                         <span className="option-label-rec">{option.title}</span>
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem disabled>No programs found</MenuItem>
//                   )
//                 ) : programOptions.length > 0 ? (
//                   programOptions.map((option) => (
//                     <MenuItem
//                       key={option.id}
//                       onClick={() => {
//                         handleOptionChange(option, activeTab); // Update local state or perform actions
//                         dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
//                       }}
//                       style={{
//                         fontFamily: "Mazzard",
//                         color: "#242730",
//                         fontSize: "16px",
//                         fontWeight: "500",
//                       }}
//                     >
//                       <span
//                         style={{
//                           whiteSpace: "normal",
//                           wordWrap: "break-word",
//                           overflowWrap: "break-word",
//                           maxWidth: "100%", // Ensure it stays within the MenuItem width
//                         }}
//                         className="option-label-rec"
//                       >
//                         {option.title}
//                       </span>
//                     </MenuItem>
//                   ))
//                 ) : (
//                   <MenuItem disabled>No programs found</MenuItem>
//                 )}
//               </Box>
//             </Popover>
//           </div>
//         </div>

//         <div
//           className="tab-button"
//           style={{ paddingRight: "0", marginRight: "0" }}
//         >
//           <Button
//             className="help-button"
//             style={{ marginRight: "20px" }}
//             onClick={toggleModal}
//           >
//             <img src={NeedHelp} alt="Need Help" />{" "}
//             <span
//               style={{
//                 color: "#2D2D2D",
//                 fontWeight: "600",
//                 fontFamily: "mazzard",
//               }}
//             >
//               Need Help?
//             </span>
//           </Button>
//         </div>
//         <RightModal isOpen={isModalOpen} toggleModal={toggleModal} />
//       </div>

//       <div>
//         {activeTab === 0 && jozunaDuration === null ? (
//           <div className="noreccomendation">
//             <img src={NoRecommendationImage} alt="No Recommendation" />
//             <p>No course has been assigned to this program</p>
//           </div>
//         ) : (
//           <div
//             className="scrollable-content"
//             style={{
//               height:
//                 LocalStorage.getLocalData("fromFlutter") !== "true"
//                   ? "calc(100vh - 150px)"
//                   : "calc(100vh - 80px)",
//             }}
//           >
//             <JozunaSkillUp
//               assessmentFound={assessmentFound}
//               type="Jozuna"
//               activeTab={activeTab}
//               jozunaData={cardData}
//               industryData={industry}
//               industryDuration={industryDuration}
//               jozunaDuration={jozunaDuration}
//               program_title={selectedOption?.title}
//               program_description={selectedOption?.description}
//               jozuna_title={selectedOptionJozuna?.title}
//               jozuna_description={selectedOptionJozuna?.description}
//               jozuna_program_id={selectedOptionJozuna?.id}
//               industry_program_id={selectedOption?.id}
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VideoLandingPage;







import { useEffect, useState } from "react";
import TabNavigator from "../components/TabNavigatorComponent";
import JozunaSkillUp from "../components/JozunaSkillUpVedioPage";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/JozunaSkillUpPageStyle.css";
import { useAlert } from "../../../../components/AlertContextComponent";
import { useApi } from "../../../../service/ApiContext";
import Logger from "../../../../utils/Logger";
import {
  Recommendation,
  videoLandingPageResponse,
} from "../data/response/VideoLandingPageResponse";
import "../../vedio-recommendation/styles/TabNavigatorStyle.css";
import AssessmentNotFound from "../../../../assets/images/recommandation/assessmentNotFound.png";
import { videolandingPageRequest } from "../data/request/VideoLandingPageRequest";
import VideoLandingPageClient from "../data/api/VideoLandingPageClient";
import Loader, { LocalStorage } from "../../../../utils/Utils";
import { recommendationIndustryViewInstance_Store } from "./../../recommendation_industry_view/data/instance_store/Recommendation_IndustryView_Instance";
import { recommendationJozunaViewInstance_Store } from "../../recommendationJozunaView/data/instance_store/Recommendation_JozunaView_Instance";
import NoRecommendationImage from "../../../../assets/images/norecommendation_screen.svg";
import NoProgramHubImage from "../../../../assets/images/noProgramHubImg.png";

import { Box, Button, MenuItem, Popover } from "@mui/material";
import DropDown from "../../../../assets/images/recommandation/dropdown.svg";
import NeedHelp from "../../assets/images/NeedHelp.svg";
import RightModal from "../../needHelp/pages/NeedHelpPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { setJozunaSelectedProgram } from "../data/redux/JozunaDropdown";
import { logActionEvent } from "../../../../analytics/analytics_utils";
import analytics_strings from "../../../../analytics/analytics_strings";

type VideoLandingPageProps = {
  activeTb: number; // Adjust the type as needed
};
const VideoLandingPage: React.FC<VideoLandingPageProps> = ({ activeTb }) => {
  // State to track active tab
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const location = useLocation();
  const active = location.state?.active;
  const [activeTab, setActiveTab] = useState(activeTb);
  const api = useApi();
  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };
  const [isModalOpen, setModalOpen] = useState(false); // State to control modal visibility
  const [industry, setIndustryData] = useState<Recommendation[] | null>(null);
  const [cardData, setCardData] = useState<Recommendation[] | null>(null);
  const [jozunaRecommendation, setJozunaRecommendation] = useState<string>("");
  const [jozunaDuration, setJozunaDuration] = useState(0);
  const [industryDuration, setIndustryDuration] = useState(0);
  const [assessmentFound, setAssessmentFound] = useState(false);
  //Loading to fix Flickering Issue
  const [loading, setLoading] = useState(false);
  const [Apptoken, setAppToken] = useState<string | null>(null);
  // const [fromFlutter, setFromFlutter] = useState(false);
  const state=location.state
  const dispatch = useDispatch();
  const selectedProgram = useSelector(
    (state: RootState) => state.JozunaDropdown.JozunaSelectedProgram
  );

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  // Retrieve saved selection from localStorage on page load
  useEffect(() => {
    const savedOption =
      activeTab === 0
        ? JSON.parse(
            LocalStorage.getLocalData("selectedOptionJozuna") || "null"
          )
        : JSON.parse(LocalStorage.getLocalData("selectedOption") || "null");

    if (savedOption) {
      if (activeTab === 0) {
        setSelectedOptionJozuna(savedOption);
      } else {
        setSelectedOption(savedOption);
      }
      getCourseDetail(activeTab, savedOption.id); // Load the corresponding course
    } else {
      // getProgram(); // Load default program data
    }
  }, [activeTab]);

  const query = useQuery();
  useEffect(() => {
    const tokenFromURL = query.get("token");
    const regionFromURL = query.get("region");
    // Handling token
    if (tokenFromURL) {
      Logger.info("Token successfully retrieved from URL:", tokenFromURL);
      LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No token found in URL. Using appToken:");
      const storedToken = LocalStorage.getLocalData("access_token");
      Logger.info(
        "No token found in URL. Using appToken**************:",
        storedToken
      );

      if (storedToken) {
        setAppToken(storedToken); // Use the token from local storage if not found in URL
        LocalStorage.setLocalData("access_token", storedToken);
      }
    }

    // Handling region
    if (regionFromURL) {
      Logger.info("Region successfully retrieved from URL:", regionFromURL);
      LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No region found in URL.");
    }
    // Check if data for the current tab has already been loaded
    if (
      (activeTab === 0 && jozunaRecommendation !== "jozuna") ||
      (activeTab === 1 && !industry)
    ) {
      getProgram();
    }
    return () => {
      recommendationIndustryViewInstance_Store.clearState(); //Clean Up Recommendation Industry View SelectedItem
      recommendationJozunaViewInstance_Store.clearState(); //Clean Up Recommendation Jozuna View SelectedItem
    };
  }, [activeTab, jozunaRecommendation, industry]);
  const getCourseDetail = async (tab: number, id: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);
    const param: videolandingPageRequest = {
      recommendation_type: tab == 0 ? "Jozuna" : "Industry",
      program_id: id,
    };
    Logger.info("param", param);
    Logger.info("Selected options", selectedOption?.title);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      // showAlert({
      //   show: true,
      //   title: "Session Expired",
      //   message: "Session timed out. Please login again",
      //   button1Text: "OK",
      //   alertType: "success",
      //   onlyNeedOneButton: true,
      //   btn1onPressed: () => {
      //     LocalStorage.deleteAllLocalData();
      //     // Use history.replaceState to avoid adding a new history entry
      //     // window.history.replaceState({}, "", "/");
      //     // window.location.reload(); // Optional: Reload to reflect changes
      //     const envUrl =
      //       process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
      //     window.parent.postMessage("logout", "*");
      //     // if (window.top) {
      //     //   Logger.error("window top link");
      //     //   window.top.location.reload();

      //     //   window.top.location.href =
      //     //     process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
      //     // } else {
      //     //   // Fallback in case window.top is null
      //     //   Logger.error(
      //     //     "Unable to access window.top. Redirecting within iframe."
      //     //   );
      //     //   window.location.href =
      //     //     process.env.REACT_APP_ENV_URL || "https://user-dev.jozuna.com/";
      //     // }
      //   },
      // });
      const response = await api.get<videoLandingPageResponse>(
        VideoLandingPageClient.landingPageURL,
        param
      );
      Logger.info("response", response.data);
      if (response.data.error != null) {
        showAlert({
          show: true,
          title: "Error",
          message: response.data.error,
          button1Text: "Cancel",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {
            ("");
          },
        });
      } else if (
        response.data.recommendation.length === 0 &&
        response.data.error == null
      ) {
        setAssessmentFound(true);
      } else {
        setAssessmentFound(false);
      }
      const courseData = response.data.recommendation || [];
      const type = response.data.recommendation_type.toLowerCase();
      const sortedCourseData = courseData.sort(
        (a, b) => a.seq_number - b.seq_number
      );
      // Sort the courseData immediately before setting it to state
      if (type === "industry") {
        setIndustryData(sortedCourseData);
        setIndustryDuration(response.data.total_duration);
      } else if (type === "jozuna") {
        setJozunaDuration(response.data.total_duration);
        setCardData(sortedCourseData);
        setJozunaRecommendation("jozuna");
      }
    } catch (error) {
      Logger.info("error response", error);
      if (activeTab == 1) {
        setIndustryData([]);
        setIndustryDuration(0);
      } else {
        setJozunaDuration(0);
        setCardData([]);
      }
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };

  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const [programOptions, setProgramOptions] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [selectedOption, setSelectedOption] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [programOptionsJozuna, setProgramOptionsJozuna] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [selectedOptionJozuna, setSelectedOptionJozuna] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [selectedId, setSelectedId] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const handleClickDrop = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleOptionChange = (
    option: {
      id: string;
      title: string;
      description: string;
    },
    tab: number
  ) => {
    if (tab === 0) {
      setSelectedOptionJozuna(option);
      // dispatch(setJozunaSelectedProgram(option));
      Logger.info("option", selectedProgram);
    }
    if (tab === 1) {
      setSelectedOption(option);
      // dispatch(setSelectedOptions(option)); // Redux action for other tabs
      // dispatch(setJozunaSelectedProgram(option));
    }
    setSelectedId(option.id);
    getCourseDetail(activeTab, option.id);
    setSelectedDesc(option.description);
    setAnchorEl2(null);
    Logger.info("selected option", selectedOption);
    Logger.info("selected Idd", selectedId);
    dispatch(setJozunaSelectedProgram(option)); // Save the selected program to Redux
    setIsOpen(false);
  };

useEffect(() => {
  Logger.info("Redux selectedProgram updated:", selectedProgram);
}, [selectedProgram]);
  // const handleOptionChange = (
  //   option: {
  //     id: string;
  //     title: string;
  //     description: string;
  //   },
  //   tab: number
  // ) => {
  //   if (tab == 0) {
  //     setSelectedOptionJozuna(option);
  //   }
  //   if (tab == 1) {
  //     setSelectedOption(option);
  //   }
  //   setSelectedId(option.id);
  //   getCourseDetail(activeTab, option.id);
  //   setSelectedDesc(option.description);
  //   setAnchorEl2(null);
  //   Logger.info("selected option", selectedOption);
  //   Logger.info("selected Idd", selectedId);
  //   setIsOpen(false);
  // };

  const getProgram = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const param = {
      domain_name: activeTab === 0 ? "Jozuna" : "Industry",
      offset_time: "+5:30",
    };

    try {
      const response = await api.get<any>("/assessment/names", param);

      // Dispatch programs to Redux store
      Logger.info("response for details", response.data);

      // Map program data to options
      const options = response.data.assessment_names.map((program: any) => ({
        id: program.assessment_entity_id,
        title: program.assessment_name,
        // description: program.program_description,
      }));

      if (options.length === 0) return;

      // ✅ Always pick first option if nothing selected
      // const defaultOption = selectedProgram ?? options[0];


// get assessment_id from route state
const stateAssessmentId = state?.assessment_id;

// try to match assessment_entity_id from API
const matchedOption = stateAssessmentId
  ? options.find((opt: { id: any; }) => opt.id === stateAssessmentId)
  : null;

// final default selection

// 1️⃣ Try Redux
const reduxMatch = selectedProgram
  ? options.find((opt: { id: any; }) => opt.id === selectedProgram.id)
  : null;

// 2️⃣ Try route state
const routeMatch = stateAssessmentId
  ? options.find((opt: { id: any; }) => opt.id === stateAssessmentId)
  : null;

// 3️⃣ Final fallback
const defaultOption = reduxMatch ?? routeMatch ?? options[0];


      // // Set options based on activeTab
      // if (activeTab === 0) {
      //   setProgramOptionsJozuna(options);
      // } else {
      //   setProgramOptions(options);
      // }

      if (activeTab === 0) {
        setProgramOptionsJozuna(options);
        setSelectedOptionJozuna(defaultOption);
      } else {
        setProgramOptions(options);
        setSelectedOption(defaultOption);
      }

      dispatch(setJozunaSelectedProgram(defaultOption));
      Logger.info("defaultOption", defaultOption);
      getCourseDetail(activeTab, defaultOption.id);

      // // Find the active program
      // const activeProgram =
      //   response.data.assessment_names.find(
      //     (program: any) => program.status === "Active"
      //   ) || response.data.programs[0];

      // if (activeProgram) {
      //   const selectedOption = {
      //     id: selectedProgram?.id,
      //     title: selectedProgram?.description,
      //     description: selectedProgram?.title,
      //   };

      //   const id = selectedProgram?.id;
      //   const desc = selectedProgram?.description;
      //   setSelectedDesc(desc);

      //   Logger.info("idd", id);

      //   // Set selected option based on activeTab
      //   if (activeTab === 0) {
      //     setSelectedOptionJozuna(selectedOption);
      //   } else {
      //     setSelectedOption(selectedOption);
      //     setSelectedId(id);
      //   }

      //   Logger.info("Selected Options:", selectedOption);
      //   Logger.info("Selected Options id:", selectedId);

      //   Logger.info("Selected Jozuna Options:", selectedOptionJozuna);

      //   // if (!selectedProgram) {
      //   //   dispatch(setJozunaSelectedProgram(selectedOption));
      //   // }

      //   // // Call getEvents only after setting selectedOption
      //   // getCourseDetail(activeTab, id);

      //   if (!selectedProgram) {
      //     console.log("first options");
      //     const firstOption = options[0]; // Select the first program by default
      //     setSelectedDesc(firstOption.description);
      //     if (activeTab === 0) {
      //       setSelectedOptionJozuna(firstOption);
      //     } else {
      //       setSelectedOption(firstOption);
      //     }
      //     dispatch(setJozunaSelectedProgram(firstOption)); // Dispatch to Redux
      //     getCourseDetail(activeTab, firstOption.id); // Load the corresponding course
      //   } else {
      //     getCourseDetail(activeTab, id);
      //   }
      // }
    } catch (error) {
      Logger.info("error response", error);
      // Display an error alert or message if needed
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="landing-page"></div>;
  }

  // Function to toggle modal open/close
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
    if (!isModalOpen) {
      logActionEvent(
        analytics_strings.analytics_events.reccomendation_needHelp,
        {
          candidate_id: userData.candidate_id,
        }
      );
    }
  };
  if (programOptionsJozuna.length === 0) {
    return (
      <div
        className="noprogram-landing-page"
        style={{
          height:
            LocalStorage.getLocalData("fromFlutter") !== "true"
              ? "90vh"
              : "100vh",
        }}
      >
        <div className="reco-assessment-not-found-container">
          <img
            src={NoProgramHubImage}
            alt="assessment not found"
            className="noprogram-assessment-not-image"
          />
          <div className="assessment-not-image-text">
            No course has been assigned to this program
          </div>
        </div>
      </div>
    );
  }
  return (
     <div>
      <div className="desktop-ui_assessmentCheck">
   
    <div
      className="landing-page"
      style={{
        height:
          LocalStorage.getLocalData("fromFlutter") !== "true"
            ? "90vh"
            : "100vh",
      }}
    >
      {/* <div className="tab-navigator">
        <TabNavigator activeTab={activeTab} onTabChange={handleTabChange} />
      </div> */}
      <div className="program-dropdown-tab">
        <div className="program-dropdown">
          <div className="program-dropdown-text">Assessments :</div>
          <div className="dropdown">
            <div className="dropdown-select" onClick={handleClickDrop}>
              {activeTab === 0
                ? selectedProgram
                  ? selectedProgram.title
                  : "Select an Option"
                : selectedOption
                ? selectedOption?.title
                : "Select an Option"}
              <img
                src={DropDown}
                alt="Checkbox Icon"
                style={{ width: "12px", height: "15px", marginLeft: "auto" }}
              />
            </div>
            <Popover
              open={Boolean(anchorEl2)}
              anchorEl={anchorEl2}
              onClose={handleClose2}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              PaperProps={{
                style: {
                  width: "300px",
                  marginTop: "5px",
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  boxShadow: "#00000040",
                  padding: "8px 8px",
                },
              }}
            >
              <Box sx={{ padding: "0px" }}>
                {activeTab === 0 ? (
                  programOptionsJozuna.length > 0 ? (
                    programOptionsJozuna.map((option) => (
                      <MenuItem
                        key={option.id}
                        onClick={() => {
                          handleOptionChange(option, activeTab); // Update local state or perform actions
                          // dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
                        }}
                        style={{
                          fontFamily: "Mazzard",
                          color: "#242730",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        <span className="option-label-rec">{option.title}</span>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No programs found</MenuItem>
                  )
                ) : programOptions.length > 0 ? (
                  programOptions.map((option) => (
                    <MenuItem
                      key={option.id}
                      onClick={() => {
                        handleOptionChange(option, activeTab); // Update local state or perform actions
                        dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
                      }}
                      style={{
                        fontFamily: "Mazzard",
                        color: "#242730",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      <span
                        style={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          maxWidth: "100%", // Ensure it stays within the MenuItem width
                        }}
                        className="option-label-rec"
                      >
                        {option.title}
                      </span>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No programs found</MenuItem>
                )}
              </Box>
            </Popover>
          </div>
        </div>

        <div
          className="tab-button"
          style={{ paddingRight: "0", marginRight: "0" }}
        >
          {/* <Button
            className="help-button"
            style={{ marginRight: "20px" }}
            onClick={toggleModal}
          >
            <img src={NeedHelp} alt="Need Help" />{" "}
            <span
              style={{
                color: "#2D2D2D",
                fontWeight: "600",
                fontFamily: "mazzard",
              }}
            >
              Need Help?
            </span>
          </Button> */}
        </div>
        {/* <RightModal isOpen={isModalOpen} toggleModal={toggleModal} /> */}
      </div>

      <div>
        {activeTab === 0 && jozunaDuration === null ? (
          <div className="noreccomendation">
            <img src={NoRecommendationImage} alt="No Recommendation" />
            <p>No course has been assigned to this program</p>
          </div>
        ) : (
          <div
            className="scrollable-content"
            style={{
              height:
                LocalStorage.getLocalData("fromFlutter") !== "true"
                  ? "calc(100vh - 150px)"
                  : "calc(100vh - 80px)",
            }}
          >
            <JozunaSkillUp
              assessmentFound={assessmentFound}
              type="Jozuna"
              activeTab={activeTab}
              jozunaData={cardData}
              industryData={industry}
              industryDuration={industryDuration}
              jozunaDuration={jozunaDuration}
              program_title={selectedOption?.title}
              program_description={selectedOption?.description}
              jozuna_title={selectedOptionJozuna?.title}
              jozuna_description={selectedOptionJozuna?.description}
              jozuna_program_id={selectedOptionJozuna?.id}
              industry_program_id={selectedOption?.id}
            />
          </div>
        )}
      </div>
    </div></div>
          <div className="mobile-ui_assessmentCheck"><p>The Recommendation is not accessible on mobile devices.</p> </div>
    </div>
  );
};

export default VideoLandingPage;